import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
export const TransformationSummary = () => {
  return <section className="mb-12" data-id="element-409">
      <p className="mb-6 text-gray-800 leading-relaxed" data-id="element-410">
        Lisa herkent dit moment: "Het kwartje viel toen Amee uitlegde hoe honden
        vanuit hun natuur gewend zijn met elkaar om te gaan. Ik begreep dat
        Benny helemaal niet koppig was - hij begreep mij gewoon niet, net zoals
        ik hem niet begreep. We hadden gewoon langs elkaar heen gecommuniceerd."
      </p>

      <div className="bg-blue-50 border border-blue-100 rounded-xl p-8" data-id="element-411">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-412">
          Wat deelnemers ontdekken:
        </h3>

        <div className="space-y-5 mb-8" data-id="element-413">
          <div className="flex items-start" data-id="element-414">
            <CheckCircle2Icon className="w-7 h-7 text-green-500 mr-4 mt-0.5 flex-shrink-0" data-id="element-415" />
            <p className="text-lg text-gray-800" data-id="element-416">
              <span className="font-bold" data-id="element-417">Dat onrustige gedrag?</span> Vaak
              mentale vermoeidheid, niet fysieke energie.
            </p>
          </div>
          <div className="flex items-start" data-id="element-418">
            <CheckCircle2Icon className="w-7 h-7 text-green-500 mr-4 mt-0.5 flex-shrink-0" data-id="element-419" />
            <p className="text-lg text-gray-800" data-id="element-420">
              <span className="font-bold" data-id="element-421">Die korte blikken naar de deur?</span>{' '}
              Je hond probeert je mee te nemen naar iets interessants.
            </p>
          </div>
          <div className="flex items-start" data-id="element-422">
            <CheckCircle2Icon className="w-7 h-7 text-green-500 mr-4 mt-0.5 flex-shrink-0" data-id="element-423" />
            <p className="text-lg text-gray-800" data-id="element-424">
              <span className="font-bold" data-id="element-425">
                Dat wegkijken wanneer je hem roept?
              </span>{' '}
              Respect, geen negeren.
            </p>
          </div>
        </div>

        <p className="text-lg text-gray-800 leading-relaxed italic" data-id="element-426">
          In 90 minuten leer je eindelijk wat je hond al die tijd probeerde te
          zeggen. Het eerstvolgende gratis{' '}
          <span className="text-blue-600 not-italic" data-id="element-427">webinar</span> is vandaag
          en morgen.
        </p>
      </div>

      <p className="text-xl text-gray-900 font-bold text-center mt-8" data-id="element-428">
        Soms kan anderhalf uur alles veranderen in de relatie met je hond
      </p>
    </section>;
};